import i18n from 'live/services/i18n'
import globalNotification from 'live/services/global-notification'
import { handleFetchErrors, entityReplacer } from './utils'

export function createTubularsByDepth(body: any): Promise<any> {
    return fetch(`/services/plugin-static-data-manager/tubulartype/createbydepth`, {
        method: 'POST',
        body: JSON.stringify(body, entityReplacer),
        headers: { 'Content-Type': 'application/json' }
    })
        .then(handleFetchErrors)
        .then(r => r.json().then(data => ({ status: r.status, body: data })))
        .then(res => {
            globalNotification.success(i18n(`Entity tubulartype by depth created successfully.`))

            return res.body
        })
        .catch((err: Response) => {
            err.json()
                .then(json => globalNotification.error(`${i18n('unablecreatetubbydepth')} \n ${json.message || ''}`))
                .catch(globalNotification.error(i18n(`${i18n('unablecreatetubbydepth')} \n ${err.status || ''}`)))

            return Promise.reject()
        })
}
